import { ref } from "vue";

export const visibleOptionsHappy = ref<boolean[]>([])